import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button } from '../Button';
import { Input } from '../Input';
import './Register.scss';

var Register = function Register(_ref) {
  var message = _ref.message,
      onRegister = _ref.onRegister;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      name = _useState2[0],
      setName = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      surname = _useState4[0],
      setSurname = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      username = _useState6[0],
      setUsername = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      password = _useState8[0],
      setPassword = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      passwordRe = _useState10[0],
      setPasswordRe = _useState10[1];

  var handleRegister = function handleRegister() {
    onRegister(name, surname, username, password, passwordRe);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "pwd-register-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pwd-register-form"
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Name",
    value: name,
    autocomplete: "off",
    onChange: setName
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Surname",
    value: surname,
    autocomplete: "off",
    onChange: setSurname
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Username",
    value: username,
    autocomplete: "off",
    onChange: setUsername
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Password",
    placeholder: "******",
    type: "password",
    value: password,
    onChange: setPassword
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Repeat password",
    placeholder: "******",
    type: "password",
    value: passwordRe,
    onChange: setPasswordRe
  }), /*#__PURE__*/React.createElement(Button, {
    text: "Register",
    onClick: handleRegister
  }), message && /*#__PURE__*/React.createElement("span", {
    className: "pwd-register-error"
  }, message)));
};

export default Register;